import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

const RESERVA_USD = '30';
const TNO_URL = 'https://www.tnonetwork.com';
const HERO_IMAGE_URL = '/images/FlaviaSanchezEstudioTNO.jpeg';

function openWhatsAppReserva() {
  const phoneNumber = '+584222020113';
  const message = `Hola, quiero reservar mi cupo para Oratoria Estratégica en TNO. ¿Cómo hago el pago de la reserva de $${RESERVA_USD}?`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
}

const Hero = () => {
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography
            sx={{ textTransform: 'uppercase', fontWeight: 700, letterSpacing: 1 }}
            variant="overline"
            color="primary"
            display="block"
            gutterBottom
          >
            Espacios TNO Academy presenta
          </Typography>
          <Box
            component={Typography}
            fontWeight={900}
            variant="h3"
            gutterBottom
            color={theme.palette.text.primary}
            sx={{ lineHeight: 1.05 }}
          >
            Domina el arte de influir: Tu voz es tu activo más valioso.
          </Box>
          <Typography
            variant="h6"
            component="p"
            color="textSecondary"
            sx={{ fontStyle: 'italic', mb: 2 }}
          >
            Una experiencia de Oratoria Estratégica en el primer ecosistema de comunicaciones digitales de Venezuela.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph sx={{ maxWidth: 680 }}>
            Entrena en un entorno real: micrófonos, cámaras y feedback experto dentro de{' '}
            <Box
              component="a"
              href={TNO_URL}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit', fontWeight: 800, textDecoration: 'underline' }}
            >
              TNO Network
            </Box>
            .
            Aquí más que hablar aprenderás a <strong>influir</strong>.
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1.5} mt={2}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={openWhatsAppReserva}
            >
              Reserva tu cupo con ${RESERVA_USD}
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} md={5}>
          <Box
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              position: 'relative',
              minHeight: { xs: 220, md: 320 },
              bgcolor: 'grey.900',
              backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, rgba(0,0,0,0.45) 65%), url(${HERO_IMAGE_URL})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              boxShadow: theme.shadows[6],
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                opacity: 0.07,
                backgroundImage:
                  'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.35), transparent 45%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.18), transparent 45%), radial-gradient(circle at 40% 80%, rgba(255,255,255,0.22), transparent 50%)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'flex-end',
                p: 3,
              }}
            >
              <Box
                sx={{
                  px: 2,
                  py: 1.25,
                  borderRadius: 2,
                  bgcolor: 'rgba(0,0,0,0.55)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  backdropFilter: 'blur(6px)',
                }}
              >
                <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 700 }}>
                  Laboratorio real en TNO
                </Typography>
                <Typography variant="h6" sx={{ color: 'common.white', fontWeight: 800, lineHeight: 1.15 }}>
                  Micrófono. Cámara. Presencia.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;

